const upsellProducts2nd = document.querySelectorAll('.upsell-product');
const productsVariantId = document.querySelectorAll('.extra-product-input.extra-product');
const productsQuantity = document.querySelectorAll('.extra-product-qty.extra-product');
const checkoutPriceButton = document.querySelector('.checkout-now-price');
const plusInput = document.querySelector(".field_quantity .js-add-button");
const minusInput = document.querySelector(".field_quantity .js-minus-button");
const currentQty = document.querySelector(".field_quantity .js-input-value");

// --- replace your formatPrice with this ---
function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
  if (isNaN(number) || number == null) return '0';
  const parts = (number / 1).toFixed(precision).split('.');
  const dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
  return parts.length > 1 ? dollars + decimal + parts[1] : dollars;
}

function formatPrice(cents, format = window.shopCurrency || '{{amount}}') {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  const placeholder = /\{\{\s*(\w+)\s*\}\}/;
  const m = format.match(placeholder);
  const value = typeof cents === 'number' ? cents : Number(cents);
  const token = m ? m[1] : 'amount';

  let formatted;
  switch (token) {
    case 'amount':
      formatted = formatWithDelimiters(value / 100, 2);
      break;
    case 'amount_no_decimals':
      formatted = formatWithDelimiters(Math.round(value / 100), 0);
      break;
    case 'amount_with_comma_separator':
      formatted = formatWithDelimiters(value / 100, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      formatted = formatWithDelimiters(Math.round(value / 100), 0, '.', ',');
      break;
    case 'amount_with_space_separator':
      formatted = formatWithDelimiters(value / 100, 2, ' ', '.');
      break;
    case 'amount_no_decimals_with_space_separator':
      formatted = formatWithDelimiters(Math.round(value / 100), 0, ' ', '.');
      break;
    default:
      formatted = formatWithDelimiters(value / 100, 2);
  }
  return format.replace(placeholder, formatted);
}
window.formatPriceHandler = formatPrice;

function getUpsellPriceCents(item) {
  // 1) If variant price already stored on checkbox (your controller flow), use it
  const offerAttr = item.querySelector('.upsell-product--checkbox')?.getAttribute('data-offer-product-price');
  if (offerAttr) return Number(offerAttr) || 0;

  // 2) Otherwise read from the JSON you already embed in each upsell card
  //    This JSON maps variant.id -> { origin_price, compare_at_price }
  try {
    const retailMap = JSON.parse(item.querySelector('.json-data-retail')?.textContent || '{}');
    // If a variant is selected in the <select>, use that; else fall back to first key
    const selectedVariantId = item.querySelector('.upsell-variant-selector')?.value;
    if (selectedVariantId && retailMap[selectedVariantId]?.origin_price != null) {
      return Number(retailMap[selectedVariantId].origin_price) || 0;
    }
    const firstKey = Object.keys(retailMap)[0];
    if (firstKey && retailMap[firstKey]?.origin_price != null) {
      return Number(retailMap[firstKey].origin_price) || 0;
    }
  } catch (e) {}

  // 3) Last-ditch: parse visible text (least reliable, but better than NaN)
  const txt = item.querySelector('.upsell-price')?.textContent || '';
  const digits = txt.replace(/[^\d]/g, '');
  return Number(digits) || 0;
}


function selectHandler(select, index) {
  Array.from(select).forEach(option => {
    if (option.selected) {
      productsVariantId[index].setAttribute('value', option.value);
    }
  })
}

upsellProducts2nd.forEach((product, index) => {
  const select = product.querySelector('select');
  product.addEventListener('click', () => {

    setTimeout(() => {
      if (!product.classList.contains('controller-products')) {
        if (product.classList.contains('checked')) {
          if (select) {
            selectHandler(select, index);
          }
          productsVariantId[index].removeAttribute('disabled');
          productsQuantity[index].removeAttribute('disabled');
        } else {
          productsVariantId[index].setAttribute('disabled', '');
          productsQuantity[index].setAttribute('disabled', '');
          setNewPriceHandler(currentQty.value);
        }
      }
    }, 0);
  })

  select && select.addEventListener('change', () => {
    selectHandler(select, index)

    if (product.classList.contains('see-popup')) {
      product.classList.remove('popup-check', 'select-check', 'see-popup', 'custom-checked', 'shake-anim');

      const label = product.querySelector('label');
      if (label) label.click();
    }
  })

  if (select && product.classList.contains('popup-check') && !product.classList.contains('see-popup')) {
    const selectWrapper = product.querySelector('.upsell-variant-selector-wrapper')
    selectWrapper.addEventListener('click', () => {
      if (!product.classList.contains('extra-see-popup')) {
        document.body.classList.add('show-check-popup-pdp');
        product.classList.add('see-popup', 'custom-checked');
        product.classList.add('extra-see-popup');
      }
    })
  }

  if (product.classList.contains('controller-products')) {
    setTimeout(() => {
      const label = product.querySelector('.label-js-elem');
      label.click();
      label.click();
    }, 0);
  }
});

function setProductVaraint(product, selects, jsonData) {
  const priceElem = product.querySelector('.upsell-price');
  const comparePriceElem = product.querySelector('.compare-price');
  const jsonDataRetails = JSON.parse(product.querySelector('.json-data-retail').textContent);

  let variantTitle = '';
  let variantId = null;
  let variantAvailable = true;
  let variantName = '';
  let variantPrice = 0;
  let variantComparePrice = 0;

  selects.forEach((select, index) => {
    Array.from(select).forEach(option => {
      if (option.selected == true) {
        variantTitle = option.value;
      }
    })
    // variantTitle = variantTitle + select.value;
    // if (index + 1 < selects.length) {
    //   variantTitle = variantTitle;
    // }
  });

  // console.log('variantTitle', variantTitle);
  // console.log('selects', selects);

  jsonData.forEach(variant => {
    if (variant.id == variantTitle) {
      variantId = variant.id;
      variantAvailable = variant.available;
      variantName = variant.title;
      variantComparePrice = variant.compare_at_price;
      variantPrice = variant.price;
    }
  });

  // console.log('variantId', variantId);
  // console.log('variantPrice', variantPrice);
  // console.log('variantComparePrice', variantComparePrice);

  if (variantId) {

    const originRetail = product.querySelector('.origin-retail');
    const comparePrice = product.querySelector('.compare-retail');

    if (jsonDataRetails[variantName]) {
      // console.log(jsonDataRetails[variantName]);
      // console.log(variantName);

      originRetail.innerText = formatPrice(jsonDataRetails[variantName].origin_price);

      if (variantComparePrice > variantPrice) {
        comparePrice.innerText = formatPrice(variantComparePrice);
      } else {
        // comparePrice.innerText = '';

      }
    }

    product.setAttribute('data-variant-id', variantId);
    product.setAttribute('data-available', variantAvailable);
    // checkoutPriceButton.dataset.offerProductPrice = variantPrice;
    product.querySelector(".upsell-product--checkbox").dataset.offerProductPrice = variantPrice;
    // console.log('variantPrice', variantPrice);
    priceElem.innerText = formatPrice(variantPrice);

    setTimeout(() => {

      if (product.classList.contains('checked')) {
        setTimeout(() => {
          let newPrice = variantPrice + +checkoutPriceButton.dataset.price;
          checkoutPriceButton.innerText = ` - ${formatPrice(newPrice)}`;
          setNewPriceHandler(currentQty.value);
        }, 0);
      } else {
        checkoutPriceButton.innerText = ` - ${formatPrice(+checkoutPriceButton.dataset.productPrice)}`;
        setNewPriceHandler(currentQty.value);
      }
    }, 1);



    // console.log('checkoutPriceButton', checkoutPriceButton);
    // let newPrice = 


    if (variantComparePrice > variantPrice) {
      // comparePriceElem.innerText = formatPrice(variantComparePrice);
    }
  }

}

function setProductPadding(product) {
  const selectsWrapper = product.querySelector('.upsell-variant-selector-wrapper');
  const value = selectsWrapper.offsetHeight;

  product.setAttribute('style', `padding-bottom: ${value + 20}px !important;`)
}

const upsellProductsController = document.querySelectorAll('.upsell-product');
document.addEventListener('DOMContentLoaded', () => {

  upsellProductsController.forEach(product => {
    const jsonData = JSON.parse(product.querySelector('.json-data').textContent);
    const selects = product.querySelectorAll('.upsell-variant-selector');

    selects.forEach(select => {
      select.addEventListener('change', () => {
        setProductVaraint(product, selects, jsonData);
      })
    });

    const label = product.querySelector('.upsell-product--checkbox');
    label.addEventListener('click', () => setProductVaraint(product, selects, jsonData));

    setProductPadding(product);
  });
})

const upsellProductsSimple = document.querySelectorAll('.upsell-product');
upsellProductsSimple.forEach(item => {
  if (!item.classList.contains('controller-products')) {
    const label = item.querySelector('.label-js-elem');

    label.addEventListener('click', () => {
      setTimeout(() => {
        const priceCents = getUpsellPriceCents(item);

        if (item.classList.contains('checked')) {
          // add upsell price to current checkout price
          setTimeout(() => {
            const baseCents = Number(checkoutPriceButton.dataset.price) || 0;
            const newPriceCents = baseCents + priceCents;
            checkoutPriceButton.innerText = ` - ${formatMoney(newPriceCents)}`;
            setNewPriceHandler(currentQty.value);
          }, 0);
        } else {
          // revert to product-only price shown on the button
          const productOnlyCents =
            Number(checkoutPriceButton.dataset.productPrice) // if your theme sets this
            || Number(checkoutPriceButton.dataset.productPriceOne) // or this (your code uses data-product-price-one)
            || 0;
          const baseCents = Number(checkoutPriceButton.dataset.price) || 0;
          checkoutPriceButton.innerText = ` - ${formatMoney(baseCents + productOnlyCents)}`;
        }
      }, 0);
    });
  }
});

window.addEventListener('resize', () => {
  upsellProductsController.forEach(product => setProductPadding(product));
})

document.body.addEventListener('click', (e) => {
  if (!e.target.classList.contains('upsell-variant-selector') && !e.target.classList.contains('label-js-elem')) {
    const upsellItem = e.target.closest('.upsell-product');

    if (upsellItem) {
      upsellItem.querySelector('.upsell-product--checkbox label').click();
    }
  }
})

window.addEventListener('load', () => {
  const checkoutButton = document.querySelector('.checkout-now-price');
  checkoutButton.dataset.price = window.newPrice;
  checkoutPriceButton.innerText = ` - ${formatPrice(+window.newPrice + +window.prodPrice)}`;
})

function setNewPriceHandler(qty) {

  setTimeout(() => {
    const checkedProducts = document.querySelectorAll(".upsell-product.checked");
    if (checkedProducts.length > 0) {
      let offerPrice = 0;
      checkedProducts.forEach(element => {
        offerPrice = offerPrice + +element.querySelector(".upsell-product--checkbox").getAttribute("data-offer-product-price");
      });

      const newprice = +checkoutPriceButton.dataset.price + (+checkoutPriceButton.getAttribute("data-product-price-one") * qty) + offerPrice;
      checkoutPriceButton.innerText = ` - ${formatPrice(+newprice)}`
    } else {
      const newprice = +checkoutPriceButton.getAttribute("data-price") + (+checkoutPriceButton.getAttribute("data-product-price-one") * qty);
      checkoutPriceButton.innerText = ` - ${formatPrice(+newprice)}`
    }
  }, 1);
}

plusInput.addEventListener("click", () => {
  setTimeout(() => {
    setNewPriceHandler(currentQty.value);
  }, 0);
})

minusInput.addEventListener("click", () => {
  setTimeout(() => {
    setNewPriceHandler(currentQty.value);
  }, 0);
})
